import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import PropTypes from 'prop-types';
import LayoutDefault from '../../components/LayoutDefault';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import PageTitle from '../../components/PageTitle';
import Paragraph from '../../components/Paragraph';
import FormForgotten from '../../components/FormForgotten';
import withMemo from '../../decorators/withMemo';
var ForgotPasswordTemplate = function ForgotPasswordTemplate(_ref) {
  var headerProps = _ref.headerProps,
    footerProps = _ref.footerProps,
    layoutProps = _ref.layoutProps,
    pageTitleProps = _ref.pageTitleProps,
    paragraphProps = _ref.paragraphProps,
    formForgottenProps = _ref.formForgottenProps;
  return /*#__PURE__*/React.createElement(LayoutDefault, _extends({}, layoutProps, {
    header: /*#__PURE__*/React.createElement(Header, headerProps),
    title: /*#__PURE__*/React.createElement(PageTitle, pageTitleProps),
    content: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Paragraph, paragraphProps), /*#__PURE__*/React.createElement(FormForgotten, formForgottenProps)),
    footer: /*#__PURE__*/React.createElement(Footer, footerProps)
  }));
};
ForgotPasswordTemplate.propTypes = {
  headerProps: PropTypes.any,
  formForgottenProps: PropTypes.any,
  footerProps: PropTypes.any,
  layoutProps: PropTypes.any,
  pageTitleProps: PropTypes.any,
  paragraphProps: PropTypes.any
};
ForgotPasswordTemplate.defaultProps = {
  headerProps: null,
  formForgottenProps: null,
  footerProps: null,
  layoutProps: null,
  pageTitleProps: null,
  paragraphProps: null
};
export default withMemo()(ForgotPasswordTemplate);